/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ExternalServiceConfig } from './ExternalServiceConfig.js';
import {
    ExternalServiceConfigFromJSON,
    ExternalServiceConfigFromJSONTyped,
    ExternalServiceConfigToJSON,
} from './ExternalServiceConfig.js';

/**
 * 
 * @export
 * @interface ExternalServicesResponse
 */
export interface ExternalServicesResponse {
    /**
     * 
     * @type {Array<ExternalServiceConfig>}
     * @memberof ExternalServicesResponse
     */
    data?: Array<ExternalServiceConfig>;
    /**
     * 
     * @type {number}
     * @memberof ExternalServicesResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof ExternalServicesResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExternalServicesResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof ExternalServicesResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the ExternalServicesResponse interface.
 */
export function instanceOfExternalServicesResponse(value: object): boolean {
    return true;
}

export function ExternalServicesResponseFromJSON(json: any): ExternalServicesResponse {
    return ExternalServicesResponseFromJSONTyped(json, false);
}

export function ExternalServicesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalServicesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ExternalServiceConfigFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ExternalServicesResponseToJSON(value?: ExternalServicesResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ExternalServiceConfigToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

